/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface TurntableActionArgs {
  /** [rad] */
  angle: number;
  /** [s] */
  timeoutS: number;
}

export interface TurntableResultData {
}

export interface TurntableActionStateData {
}

function createBaseTurntableActionArgs(): TurntableActionArgs {
  return { angle: 0, timeoutS: 0 };
}

export const TurntableActionArgs = {
  encode(message: TurntableActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.angle !== 0) {
      writer.uint32(13).float(message.angle);
    }
    if (message.timeoutS !== 0) {
      writer.uint32(21).float(message.timeoutS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TurntableActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTurntableActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.angle = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TurntableActionArgs {
    return {
      angle: isSet(object.angle) ? globalThis.Number(object.angle) : 0,
      timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0,
    };
  },

  toJSON(message: TurntableActionArgs): unknown {
    const obj: any = {};
    if (message.angle !== 0) {
      obj.angle = message.angle;
    }
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TurntableActionArgs>, I>>(base?: I): TurntableActionArgs {
    return TurntableActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TurntableActionArgs>, I>>(object: I): TurntableActionArgs {
    const message = createBaseTurntableActionArgs();
    message.angle = object.angle ?? 0;
    message.timeoutS = object.timeoutS ?? 0;
    return message;
  },
};

function createBaseTurntableResultData(): TurntableResultData {
  return {};
}

export const TurntableResultData = {
  encode(_: TurntableResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TurntableResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTurntableResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TurntableResultData {
    return {};
  },

  toJSON(_: TurntableResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TurntableResultData>, I>>(base?: I): TurntableResultData {
    return TurntableResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TurntableResultData>, I>>(_: I): TurntableResultData {
    const message = createBaseTurntableResultData();
    return message;
  },
};

function createBaseTurntableActionStateData(): TurntableActionStateData {
  return {};
}

export const TurntableActionStateData = {
  encode(_: TurntableActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TurntableActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTurntableActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TurntableActionStateData {
    return {};
  },

  toJSON(_: TurntableActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TurntableActionStateData>, I>>(base?: I): TurntableActionStateData {
    return TurntableActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TurntableActionStateData>, I>>(_: I): TurntableActionStateData {
    const message = createBaseTurntableActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
